module.exports = __webpack_public_path__ + "img/NymbleUp-Edit Projected Transactions.937ee415.png";